import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-299f41dc")

_pushScopeId("data-v-299f41dc")
const _hoisted_1 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-body py-10 text-center text-muted" }, " Shop Products is not available for your account. ", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "col-xxl-12" }
const _hoisted_5 = { class: "card-header border-0 pt-5" }
const _hoisted_6 = { class: "card-title align-items-center" }
const _hoisted_7 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Shop Products", -1)
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Share a product checkout link with your prospects. When they pay through your link, you earn points credit. ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Your User ID (")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(") is added to every link automatically. ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Your User ID is added to every link automatically. ")
const _hoisted_14 = /*#__PURE__*/_createVNode("ol", { class: "shop-products-howto mb-0" }, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Find a product"),
    /*#__PURE__*/_createTextVNode(" — search by name, or sort by Product or Price. ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Copy your link"),
    /*#__PURE__*/_createTextVNode(" — tap the "),
    /*#__PURE__*/_createVNode("span", {
      class: "shop-products-howto-icon shop-products-howto-icon--copy",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createVNode("i", { class: "fas fa-copy" })
    ]),
    /*#__PURE__*/_createTextVNode(" copy button on that row. ")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("strong", null, "Share it"),
    /*#__PURE__*/_createTextVNode(" — tap the "),
    /*#__PURE__*/_createVNode("span", {
      class: "shop-products-howto-icon shop-products-howto-icon--share",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" })
    ]),
    /*#__PURE__*/_createTextVNode(" share button, then pick Facebook, Messenger, WhatsApp, Viber, Telegram, Email, or SMS. ")
  ])
], -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger fs-7 mb-5"
}
const _hoisted_16 = { class: "shop-products-toolbar mb-5" }
const _hoisted_17 = { class: "shop-products-search" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", {
  class: "shop-products-search-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_19 = { class: "text-muted fs-8" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_22 = { class: "text-muted fw-semibold fs-8 text-uppercase" }
const _hoisted_23 = { class: "ps-4" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Product ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Price ")
const _hoisted_26 = /*#__PURE__*/_createVNode("th", { class: "pe-4 text-end" }, "Share", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-center text-muted py-10"
}, "No products found.", -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-center text-muted py-10"
}, "No products match your search.", -1)
const _hoisted_31 = { class: "ps-4" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { class: "shop-product-thumb me-3" }
const _hoisted_34 = {
  key: 1,
  class: "shop-product-thumb-placeholder",
  "aria-hidden": "true"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fas fa-box" }, null, -1)
const _hoisted_36 = { class: "fw-semibold text-gray-800" }
const _hoisted_37 = { class: "fw-semibold text-gray-800" }
const _hoisted_38 = { class: "pe-4" }
const _hoisted_39 = { class: "shop-products-share-actions" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fas fa-share-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")

  return (_ctx.ccode !== 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: [_ctx.widgetClasses, "card seq-card"]
        }, [
          _hoisted_2
        ], 2)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_3, [
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_el_skeleton, {
            rows: 10,
            animated: ""
          })
        ], 512), [
          [_vShow, _ctx.loading]
        ]),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: [_ctx.widgetClasses, "card seq-card"]
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h3", _hoisted_6, [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Bag2.svg" })
                ]),
                _hoisted_8
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_SeqNoticeCard, {
                variant: "info",
                title: "How to use",
                icon: "media/icons/duotone/Code/Info-circle.svg",
                class: "mb-5"
              }, {
                default: _withId(() => [
                  _createVNode("p", null, [
                    _hoisted_10,
                    (_ctx.affiliateUsid)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_11,
                          _createVNode("strong", null, _toDisplayString(_ctx.affiliateUsid), 1),
                          _hoisted_12
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_13
                        ], 64))
                  ]),
                  _hoisted_14
                ]),
                _: 1
              }),
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event)),
                    type: "search",
                    class: "form-control form-control-sm shop-products-search-input",
                    placeholder: "Search products...",
                    "aria-label": "Search products"
                  }, null, 512), [
                    [_vModelText, _ctx.searchQuery]
                  ])
                ]),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.filteredProducts.length) + " of " + _toDisplayString(_ctx.products.length) + " products ", 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("table", _hoisted_21, [
                  _createVNode("thead", null, [
                    _createVNode("tr", _hoisted_22, [
                      _createVNode("th", _hoisted_23, [
                        _createVNode("button", {
                          type: "button",
                          class: "shop-products-sort-btn",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSort('name')))
                        }, [
                          _hoisted_24,
                          _createVNode("i", {
                            class: _ctx.sortIconClass('name'),
                            "aria-hidden": "true"
                          }, null, 2)
                        ])
                      ]),
                      _createVNode("th", null, [
                        _createVNode("button", {
                          type: "button",
                          class: "shop-products-sort-btn",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSort('amount')))
                        }, [
                          _hoisted_25,
                          _createVNode("i", {
                            class: _ctx.sortIconClass('amount'),
                            "aria-hidden": "true"
                          }, null, 2)
                        ])
                      ]),
                      _hoisted_26
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_ctx.products.length === 0)
                      ? (_openBlock(), _createBlock("tr", _hoisted_27, [
                          _hoisted_28
                        ]))
                      : (_ctx.filteredProducts.length === 0)
                        ? (_openBlock(), _createBlock("tr", _hoisted_29, [
                            _hoisted_30
                          ]))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: product.sku
                      }, [
                        _createVNode("td", _hoisted_31, [
                          _createVNode("div", _hoisted_32, [
                            _createVNode("div", _hoisted_33, [
                              (product.imageUrl)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: product.imageUrl,
                                    alt: product.name,
                                    class: "shop-product-thumb-image"
                                  }, null, 8, ["src", "alt"]))
                                : (_openBlock(), _createBlock("span", _hoisted_34, [
                                    _hoisted_35
                                  ]))
                            ]),
                            _createVNode("div", _hoisted_36, _toDisplayString(product.name), 1)
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatCurrency(product.amount)), 1)
                        ]),
                        _createVNode("td", _hoisted_38, [
                          _createVNode("div", _hoisted_39, [
                            _createVNode("button", {
                              type: "button",
                              class: "seq-share-btn seq-share-btn--copy",
                              title: _ctx.copiedSku === product.sku ? 'Copied!' : 'Copy share link',
                              onClick: ($event: any) => (_ctx.copyShareLink(product))
                            }, [
                              _createVNode("i", {
                                class: ["fas", _ctx.copiedSku === product.sku ? 'fa-check' : 'fa-copy']
                              }, null, 2)
                            ], 8, ["title", "onClick"]),
                            _createVNode("button", {
                              type: "button",
                              class: ["seq-share-btn seq-share-btn--share", { 'is-active': _ctx.shareOpenSku === product.sku }],
                              title: _ctx.shareOpenSku === product.sku ? 'Close share' : 'Share to social',
                              onClick: ($event: any) => (_ctx.toggleShare(product.sku))
                            }, [
                              _hoisted_40
                            ], 10, ["title", "onClick"]),
                            (_ctx.shareOpenSku === product.sku && _ctx.buildAffiliateShareUrl(product.shareUrl))
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.shareNetworks, (network) => {
                                  return (_openBlock(), _createBlock(_component_ShareNetwork, {
                                    key: product.sku + '-' + network.network,
                                    network: network.network,
                                    url: _ctx.buildAffiliateShareUrl(product.shareUrl),
                                    title: _ctx.shareTitle(product),
                                    description: _ctx.shareDescription(product),
                                    class: "seq-share-btn",
                                    style: { backgroundColor: network.color },
                                    "aria-label": network.name
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("i", {
                                        class: network.icon
                                      }, null, 2)
                                    ]),
                                    _: 2
                                  }, 1032, ["network", "url", "title", "description", "style", "aria-label"]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ], 2)
        ], 512), [
          [_vShow, !_ctx.loading]
        ])
      ]))
})